/**
 * Display a choice with a picture, a name, description and price
 * shape parameter allow to show image as a cicle or a square
 */
fx.ns("shared.components", class PosterSizeChoice extends fx.components.VBox
{    
    constructor(data, name, description, price)
    {
        super(data);
        this.name = name;
        this.description = description;
        this.price = price;
    }

    get posterSize()
    {
        let size;
        switch(this.data.format.code)
        {
            case "a1" :
                size = {width : 190, height : 270};
            break;

            case "a2" :
                size = {width : 150, height : 213};
            break;

            case "a3" :
                size = {width : 120, height : 170};
            break;

            case "a4" :
                size = {width : 100, height : 142};
            break;
        }
        return size;
    }

    create()
    {
        super.create();

        
        let posterContainer = new fx.components.Box("poster-container");
        let whitePoster = new fx.components.Box("white-poster");
        whitePoster.addChild( new fx.components.Text({text : this.description, className : "description"}), {width : "auto", height : "auto", left : "center", top : "center"});
        posterContainer.addChild( whitePoster, { width : this.posterSize.width, height : this.posterSize.height, top : "center", left : "center"} );

        this.addChild( posterContainer, { width : "100%", height : 300});
        
        let bottomContainer = new fx.components.VBox("bottom-container");

        if (this.name)
            bottomContainer.addChild( new fx.components.Text( {text : this.name, className : "name"} ), {width:"100%", height : "auto", left : "center"} );

        if (this.price)
            bottomContainer.addChild( new fx.components.Text( {text : this.price, className : "price"} ), {width:"auto", left : "center"} );

        this.addChild(bottomContainer, { width : "100%", height : "auto"});
    }

});
